import React from 'react';
import config from 'client/shared/config';
import { observer } from 'mobx-react';


const Header = observer(({ artist: { bannerImage, name } }) => (
	<>
		<header
			className="artist-banner"
			style={ {backgroundImage: `url("${config.paths.bannerImgBasePath}/${bannerImage}")`} }
			data-ta="artist-banner"
		>
			<div className="grid-x header-grid">
				<div className="cell shrink text-left">

					<div
						style={ { lineHeight: '1em ' } }
						className="artist-name-banner margin-bottom-0"
					>
						{ name }
					</div>
				</div>
				<div className="cell auto padding-left-1">
				</div>
			</div>
		</header>
	</>
));

export default Header;
